import producer from "immer";
import { getSessionStorageKey, setSessionStorageKey } from "../../../utils";

const INITIAL_STATE = {
	loading: false,
	createdStatus: "AWAIT",
	marketRegisterInfo: getSessionStorageKey("marketRegisterInfo") || {},
	marketCheckoutUser: getSessionStorageKey("marketCheckoutUser") || {},
	existingEmail: false,
	duplicityEmail: false,
	isTermAccepted: false,
	verificatedEmailDuplicity: false,
	resUpdateOnboardField: {},
	toMarket: false,
	updated_all_fields: false,
	ticketSent: false,
	ticketLoading: false,
};

export default function register(state = INITIAL_STATE, action) {
	const ACTIONS = {
		"@register/CHANGE_LOADING": (draft) => {
			draft.loading = action.payload.loading;
		},

		"@register/ONBOARDING_GOGOGO_REQUEST": (draft) => {
			draft.loading = true;
		},
		"@register/ONBOARDING_NEW_INVESTOR": (draft) => {
			const { info } = action.payload;
			setSessionStorageKey("marketRegisterInfo", info);
			draft.marketRegisterInfo = getSessionStorageKey("marketRegisterInfo");
		},
		"@register/ONBOARDING_NEW_INVESTOR_STATUS": (draft) => {
			const { status } = action.payload;
			draft.createdStatus = status;
		},
		"@register/UPDATE_CHECKOUT_REGISTER_FIELD_REQUEST": (draft) => {
			const { field, value } = action.payload;
			let sessionUser = getSessionStorageKey("marketCheckoutUser") || {};
			sessionUser[field] = value;
			setSessionStorageKey("marketCheckoutUser", sessionUser);
			draft.marketCheckoutUser = sessionUser;
		},
		"@register/ONBOARD_VALIDATING_EMAIL_RESPONSE": (draft) => {
			draft.existingEmail = action.payload.resp;
		},
		"@register/VALIDATING_EMAIL_RESP": (draft) => {
			draft.duplicityEmail = action.payload.resp;
		},
		"@register/ACCEPTED_TERMS": (draft) => {
			draft.isTermAccepted = action.payload.isTermAccepted;
		},
		"@register/SET_VERIFICATED_EMAIL_DUPLICITY": (draft) => {
			draft.verificatedEmailDuplicity = action.payload.result;
		},
		"@register/GET_RESPONSE_UPDATE_ONBOARD_FIELD": (draft) => {
			draft.resUpdateOnboardField = action.payload.param;
		},
		"@register/SENDING_TO_MARKET": (draft) => {
			draft.toMarket = action.payload.param;
		},
		"@register/UPDATED_ALL_FIELDS": (draft) => {
			draft.updated_all_fields = action.payload.updated_all_fields;
		},
		"@register/TICKET_ZENDESK_RESPONSE": (draft) => {
			draft.ticketSent = action.payload;
		},
		"@register/SEND_TICKET_LOADING": (draft) => {
			draft.ticketLoading = action.payload;
		},
	};

	return producer(state, (draft) => {
		return Object.keys(ACTIONS).indexOf(action.type) !== -1 ? ACTIONS[action.type](draft) : state;
	});
}
